import React from 'react';
import { useRefinementList } from 'react-instantsearch';
import { formatItemLabel } from '../../../../helpers/facet-helper';

const RefinementList = ({ attribute, label }) => {
    const { items, refine } = useRefinementList({ attribute });
    const itemsTransformed = items.map((item) => formatItemLabel(item));

    return (
        <div
            className="cards__sidebar cards__sidebar--insights"
            style={{ display: !itemsTransformed.length ? 'none' : '' }}
        >
            <h4 className="heading -tight">{label}</h4>
            <div className="cards__filters">
                {itemsTransformed.map((item, index) => {
                    const id = item.label.toLowerCase().replaceAll(' ', '-').replaceAll('/', '-');
                    return (
                        <div className="checkbox" key={index}>
                            <input
                                type="checkbox"
                                name="categories"
                                className="checkbox__input js-search-filter-param"
                                id={id}
                                onChange={() => {
                                    refine(item.value);
                                }}
                                checked={item.isRefined ? 'checked' : ''}
                            />
                            <label htmlFor={id} className="checkbox__label">
                                {item.label}
                            </label>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RefinementList;
